import { matchPath } from 'react-router-dom';

import { LESSON_TAB_PATHS } from '@/utils/lesson/lessonTabs';

export type ChapterReaderTab = keyof Pick<
  typeof LESSON_TAB_PATHS,
  'material' | 'teacherBook'
>;

export const toChapterReaderPaths = (tab: ChapterReaderTab) => [
  `${LESSON_TAB_PATHS[tab]}/chapter/:chapterOrder`,
  `${LESSON_TAB_PATHS[tab]}/chapter/:chapterOrder/subchapter/:subchapterOrder`,
];

export const CHAPTER_READER_PATHS = [
  ...toChapterReaderPaths('material'),
  ...toChapterReaderPaths('teacherBook'),
];

export const isChapterReaderPathname = (
  lessonPathname: string,
  pathname: string,
) =>
  CHAPTER_READER_PATHS.some(readerPath =>
    matchPath(`${lessonPathname}/${readerPath}`, pathname),
  );
